<template>
	<v-card outlined>
		<v-card-title class = "pa-0 pl-2 subtitle-2 text-uppercase">
			<span>{{ title }}</span>
			<v-spacer></v-spacer>
			<v-btn small color ="primary" @click="geoLocation()" :loading = "loading"> <v-icon small class = "mr-1">mdi-map-marker-radius</v-icon> {{ $ml.get('find_location')}}</v-btn>
		</v-card-title>
		<l-map 
			ref 	= "myMap" 
			@ready  = "doSomethingOnReady()"
			:center = "center" 
			:zoom   = "zoom" 
			@click  = "addMarker"
		>
			<l-tile-layer 
				noWrap				
				:url 		 	= "url"
				:attribution 	= "attribution"		
			></l-tile-layer>
			<l-marker 
		 		:lat-lng = "marker" 
		 		v-if 	 = "marker"
		 		@click   = "removeMarker()"
		 	>
			  <!-- 	<l-icon
					:icon-size   = "dynamicSize"
					:icon-anchor = "dynamicAnchor"
					:icon-url    = "imgIcon"
			  	>
			  	</l-icon> -->
			  	<l-tooltip 
						:options = "{ 
							permanent 	: false, 
							interactive : true 
						}"
					>
						  {{ markerName }}
					</l-tooltip>

		 	</l-marker>
		</l-map>
	</v-card>
</template>
<style 
	type = "text/css"
	scoped
>
	@import "~leaflet.markercluster/dist/MarkerCluster.css";
	@import "~leaflet.markercluster/dist/MarkerCluster.Default.css";
	.card-transparent{
		opacity: 0.5;
		z-index : 1;
		position: absolute;		
	}
</style>
<script type="text/javascript">
	import { LMap, LTileLayer, LMarker, LIcon, LPopup, LTooltip } from 'vue2-leaflet';
	import 'leaflet/dist/leaflet.css';
	import L 						from 'leaflet';
	import { Icon } 				from 'leaflet';
	delete Icon.Default.prototype._getIconUrl;
	// Icon.Default.imagePath = '.';
	Icon.Default.mergeOptions({
	  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
	  iconUrl: require('leaflet/dist/images/marker-icon.png'),
	  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
	});

	export default {
		name : "EditableMapComponent",
		components: {
			LMap,
		    LTileLayer,
		    LMarker,
		    LIcon,
			LPopup,
			LTooltip,
		},
		props:["info_to_component", "title"],
		data : ()=>({
			map  			: null,
			url  			: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			// 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png',
			attribution 	: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
			// 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png',//
		    zoom 			: 8,
		    center 			: [47.313220, -1.319482],
		    marker  		: false, 
			staticAnchor 	: [16, 37],
			iconSize 	 	: 32,
		    location 	 	: {},
		    makerFit 		: [],
		    markerName 		: "",
		    imgIcon 		: "",
		    loading 		: false,
		}),		
		watch:{
			info_to_component(val){
				if (val) {													
					this.addMarker({
	    				latlng : {
	    					lat: val.latitude, 
	    					lng : val.longitude 
	    				}
	    			});
					
				}
			}
		}, // watch
		computed:{
			dynamicSize () {
				return [this.iconSize, this.iconSize * 1.15];
			},
			dynamicAnchor () {
				return [this.iconSize / 2, this.iconSize * 1.15];
			},
		}, // computed
		methods : {
			doSomethingOnReady() {    			
    			this.$nextTick(() => {
	        		this.map = this.$refs.myMap.mapObject;	        			        			        			
	        		if (this.info_to_component) {
	        			this.addMarker({
	        				latlng : {
	        					lat: this.info_to_component.latitude, 
	        					lng : this.info_to_component.longitude 
	        				}
	        			});
	        		}	        			        		 
	        		this.onResize();
	        	}); // nextTick
	    	}, // doSomethingOnReady

	    	onResize() {				
				const resize_time = setTimeout(function() { 
					window.dispatchEvent(new Event('resize'));
					clearTimeout(resize_time);
      		 	}, 250);
			}, // on resize

			removeMarker() {		
				this.marker = null;
				this.sendLocation("", "");
			},
			addMarker(event) {						
				this.marker = null;				    					
				if (!this.marker && event && event.latlng && event.latlng.lng && event.latlng.lat) {					
					this.marker = L.latLng(event.latlng.lat, event.latlng.lng);
					this.center = L.latLng(event.latlng.lat, event.latlng.lng);				
					this.markerName  = "latitude:" + (parseFloat(event.latlng.lat)).toFixed(5) + 
										" longitude: " + (parseFloat(event.latlng.lng)).toFixed(5);
					this.sendLocation(event.latlng.lng, event.latlng.lat)				
				}
			},
		    sendLocation(long = 0, lat = 0){
		    	let location = {
		    		latitude  : lat,
		    		longitude : long,
		    	}
		    	this.$emit('receiveInfo', location);
		    }, // send location


		    geoLocation(){		    	
		    	if ("geolocation" in navigator) {
		    		this.loading = true;
		      		navigator.geolocation.getCurrentPosition((position)=> {				  
				        this.location.latitude 	= position.coords.latitude;
				        this.location.longitude = position.coords.longitude;
				        this.makerFit = [];
			        	const timer = setTimeout(()=>{
				        	this.marker = L.latLng(position.coords.latitude, position.coords.longitude);
							this.center = L.latLng(position.coords.latitude, position.coords.longitude);
							this.makerFit.push(L.latLng(position.coords.latitude, position.coords.longitude));
							this.renderBounds();
							this.onResize();
		    				this.loading = false;
							clearTimeout(timer);
			        	}, 1000)
				        	

				        
				    }, (error)=> {
	                    // Error al obtener la posición
	                    if (error) {
	                    	let msg = error.code == 1 ? `${this.$ml.get('enable_browser_permissions')}, ` : ""
		                    this.$EventBus.$emit("notifications_modal",{
		                    	type : "warning",
		                    	message : `${this.$ml.get("getting_location")} : ${msg} ${error.message} ` 
		                    })
		                    console.error('Error al obtener la posición:', error);
	                    }
		    			this.loading = false;

	                });
		      	}else{
		      		console.log("geolocation its Not  enable");
		      		this.$EventBus.$emit("notifications_modal",{
                    	type : "warning",
                    	message : this.$ml.get("geolocation_not_supported") 
                    })
		      	}
		    }, // geo location
		    renderBounds(){	  			
	  			if (this.makerFit && this.makerFit.length > 0) {
	  				const timer = setTimeout(()=>{
						let bounds = new L.LatLngBounds(this.makerFit);
						if (this.map && bounds){
							this.map.fitBounds(bounds);																			
						}else{
							console.warn("Not editable , Not found some property : ", bounds)
						}
						clearTimeout(timer);
	  				}, 550)
				}
	  		}, // render bounds

		}, // methods
		mounted() {						
			this.onResize();							
		}, // mounted
	}
</script>